"use strict";
var regexp_util_1 = require("regexp-util");
var unicode = require("unicode-regex");
var cjk_letters = unicode({
    Script: ['Han', 'Katakana', 'Hiragana', 'Hangul', 'Bopomofo'],
    General_Category: [
        'Other_Letter',
        'Letter_Number',
        'Other_Symbol',
        'Modifier_Letter',
    ]
});
var cjk_punctuations = unicode({
    Block: [
        'CJK_Symbols_And_Punctuation',
        'Vertical_Forms',
        'CJK_Compatibility_Forms',
        'Small_Form_Variants',
        'Halfwidth_And_Fullwidth_Forms',
        'Ideographic_Description_Characters',
    ]
}).subtract(cjk_letters);
var cjk_all = regexp_util_1.charset(cjk_letters, cjk_punctuations);
function cjk_regex() {
    return regexp_util_1.charset(cjk_all);
}
cjk_regex.letters = function () { return regexp_util_1.charset(cjk_letters); };
cjk_regex.punctuations = function () { return regexp_util_1.charset(cjk_punctuations); };
module.exports = cjk_regex;
